import React, { useEffect, useState } from "react";
import Switch from "../../../form/Switch";
import Select from "../../../form/Select";
import Input from "../../../form/Input";
import DatePicker from "../../../form/DatePicker";
import TransactionItem from "../../../single-items/TransactionItem";

const TransactionList = ({
  title,
  data,
  isSort = false,
  isfilter = false,
  onSearch,
  onSortChange,
  onFilterChange,
}) => {
  const [filterOn, setFilterOn] = useState(false);
  const [status, setStatus] = useState("All");
  const [sort, setSort] = useState("Desc");
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    const statusArr = status === "All" ? [] : [status.toLowerCase()]; // ensure lowercase: 'completed', 'failed'

    onFilterChange?.({
      status: statusArr,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    });
  }, [status, dateRange]);

  // console.log(data);
  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4 flex-wrap">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            {title}
          </div>
          {(isSort || isfilter) && (
            <div className="ml-auto flex items-center gap-x-4 flex-shrink-0">
              {isfilter && (
                <div className="flex items-center gap-1 md:gap-2">
                  <div className="font-medium text-md-dark text-sm">
                    Filters
                  </div>
                  <Switch
                    checked={filterOn}
                    onChange={() => setFilterOn(!filterOn)}
                  />
                </div>
              )}
              {isSort && (
                <Select
                  xPlacement={"bottomRight"}
                  selectedValue={sort}
                  dropdownData={[
                    { name: "Newest First", value: "Desc" },
                    { name: "Oldest First", value: "Asc" },
                    { name: "Alphabetical (A-Z)", value: "Alpha_A_Z" },
                    { name: "Alphabetical (Z-A)", value: "Alpha_Z_A" },
                  ]}
                  // setSelectedValue={(val) => {
                  //   setSort(val);
                  // }}
                  setSelectedValue={(val) => {
                    setSort(val);
                    const map = {
                      Desc: "-createdAt",
                      Asc: "createdAt",
                      Alpha_A_Z: "paymentGateway.transactionId",
                      Alpha_Z_A: "-paymentGateway.transactionId",
                    };
                    onSortChange?.(map[val]);
                  }}
                  dropdownClass={"min-w-[160px]"}
                />
              )}
            </div>
          )}
        </div>
        {filterOn && (
          <div className="mb-4 pb-4 border-b border-md-pink-light-1">
            <div className="flex items-center gap-1 md:gap-2 flex-wrap">
              <div className="relative w-full 3xl:w-auto min-w-72">
                <div className="h-10 aspect-square flex items-center justify-center absolute top-0 left-0 z-[1] text-base transition-all duration-300 text-md-pink">
                  <i className="fa-regular fa-magnifying-glass"></i>
                </div>
                <Input
                  inputPlaceholder={"Search"}
                  inputClasses={
                    "!pl-10 !h-10 !text-sm !pb-0.5 placeholder:!text-md-dark"
                  }
                  onChange={(e) => onSearch?.(e.target.value)}
                />
              </div>
              <div className="ml-auto flex items-center gap-1 md:gap-2 w-full 3xl:w-auto">
                <div className="relative w-full 3xl:w-auto 3xl:min-w-52">
                  {/* <DatePicker
                    value={dateRange}
                    renge={true}
                    onChange={setDateRange}
                  /> */}
                  <DatePicker
                    value={dateRange}
                    range={true}
                    onChange={(val) =>
                      setDateRange({
                        startDate: val?.startDate || null,
                        endDate: val?.endDate || null,
                      })
                    }
                  />
                </div>
                <div className="relative">
                  <Select
                    xPlacement={"bottomRight"}
                    selectedValue={status}
                    dropdownData={[
                      { name: "All Status", value: "All" },
                      { name: "Success", value: "completed" },
                      { name: "Failed", value: "failed" },
                    ]}
                    setSelectedValue={(val) => {
                      setStatus(val);
                    }}
                    dropdownClass={"min-w-[160px]"}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="relative">
          {data?.length > 0 && (
            <div className="space-y-4">
              {data?.map((item, index) => (
                <TransactionItem key={index} data={item} />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TransactionList;
